import React from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'

const EventNavigation = (props) => {
  return (
    <nav className="rider-navigation">
      <ul>
        <li><NavLink activeClassName="active" to={`${props.url}/riders`}>Riders</NavLink></li>
        {/*<li><NavLink activeClassName="active" to={`${props.url}/messages`}>Messages</NavLink></li>*/}
        {/*<li><NavLink activeClassName="active" to={`${props.url}/documents`}>Documents</NavLink></li>*/}
        {/*<li><NavLink activeClassName="active" to={`${props.url}/equipment`}>Equipment List</NavLink></li>*/}
        {/*<li><NavLink activeClassName="active" to={`${props.url}/comparison`}>Rider comparison</NavLink></li>*/}
        {/*<li><NavLink activeClassName="active" to={`${props.url}/mixer`}>Your mixer</NavLink></li>*/}
      </ul>
    </nav>
  )
}

EventNavigation.propTypes = {
  url: PropTypes.string,
  eventId: PropTypes.string
}

EventNavigation.defaultProps = {
  url: '',
  eventId: ''
}

export default EventNavigation



// WEBPACK FOOTER //
// ./src/components/event/event-navigation.js